module.exports = __webpack_public_path__ + "img/lum-light.e6b5350c.svg";